import { PermMatter } from './../api/report/PermMatter';
import { ReportSummary } from './../api/report/report-summary';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BACKEND_URL } from '../app.config';
import { OpenMatter } from './../api/report/OpenMatter';
import { ListResult } from '../api/core/list-result';
import { AlertsReport } from '../api/report/AlertsReport';
import { VisaBulletinReport } from '../api/report/VisaBulletinReport';
import { AllOpenMatter } from '../api/report/AllOpenMatter';
import { FNDetailsReport } from '../api/report/FNDetailsReport';
import { RecruitmentReport } from '../api/report/RecruitmentReport';
import { ExperienceMapReport } from '../api/report/ExperienceMapReport';
import { PERMExpiration } from '../api/report/PERMExpiration';
import { FileWithContentDto } from '../api/document';
import { LegacyReviewReport } from '../api/report/LegacyReviewReport';
import { PWDsWithoutRecruitment, PWDsWithoutRecruitmentFilter } from '../api/report/PWDsWithoutRecruitment';

@Injectable()
export class ReportService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) { }

  getList(filter: any): Observable<OpenMatter[]> {
    return this.http.get<OpenMatter[]>(this.baseUrl + '/api/app/report/open-matters', {
      params: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? [],
        companyName: filter.companyName ?? '',
      },
    });
  }
  getPermList(filter: any): Observable<PermMatter[]> {
    return this.http.get<PermMatter[]>(this.baseUrl + '/api/app/report/perm-matters', {
      params: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? [],
        companyName: filter.companyName ?? '',
      },
    });
  }

  getAlertReportList(filter: any): Observable<AlertsReport[]> {
    return this.http.get<AlertsReport[]>(this.baseUrl + '/api/app/report/alerts-report', {
      params: {
        companyName: filter.companyName ?? '',
        fnFirstName: filter.fnFirstName ?? '',
        fnLastName: filter.fnLastName ?? '',
        matterId: filter.matterId ?? '',
        status: filter.status ?? '',
      },
    });
  }
  exportToCsv(filter: any): Observable<Blob> {
    return this.http.get(this.baseUrl + '/api/app/report/exporting', {
      responseType: 'blob',
      params: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? '',
        companyName: filter.companyName ?? '',
      },
    });
  }

  getReportSummaryList(filter: any, sorting: string, skipCount: number = 0, maxResultCount: number = 10): Observable<ListResult<ReportSummary>> {
    return this.http.get<ListResult<ReportSummary>>(this.baseUrl + '/api/app/report/report-summary', {
      params: {
        idExcluded: filter.idExcluded ?? '',
        name: filter.name ?? '',
        sorting,
        skipCount: skipCount.toString(),
        maxResultCount: maxResultCount.toString(),
      },
    });
  }

  getCompanyFilterList(filterName: string) {
    return this.http.get<any[]>(this.baseUrl + '/api/app/report/company-filters', {
      params: {
        filter: filterName ?? '',
      },
    });
  }

  getVisaBulletionReport(filter: any): Observable<VisaBulletinReport[]> {
    return this.http.get<VisaBulletinReport[]>(this.baseUrl + '/api/app/report/visa-bulletin-report', {
      params: {
        month: filter.month ?? '',
        type: filter.type ?? [],
        sponsorId: filter.sponsorId ?? '',
        companyName: filter.companyName ?? '',
        gCStatus: filter.gcStatus ?? [],
      },
    });
  }

     exportVisaBulletinReportToEmail(filter: any, format: 'excel' | 'csv'): Observable<{ jobId: string }> {
    return this.http.post<{ jobId: string }>(this.baseUrl + '/api/app/report/export-visa-bulletin-report-to-email', {
      filter: {
          month: filter.month ?? '',
        type: filter.type ?? [],
        sponsorId: filter.sponsorId ?? '',
        companyName: filter.companyName ?? '',
        gCStatus: filter.gcStatus ?? [],
      },
      format: format
    });
  }


  getAllOpenMattersList(filter: any): Observable<AllOpenMatter[]> {
    return this.http.get<AllOpenMatter[]>(this.baseUrl + '/api/app/report/open-matters-report', {
      params: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? '',
        companyName: filter.companyName ?? '',
        workflowTemplate: filter.workflowTemplate ?? [],
        matterProgressStatus: filter.matterProgressStatus ?? [],
        matterOpenedDateStart: filter.matterOpenedDateStart ?? '',
        matterOpenedDateEnd: filter.matterOpenedDateEnd ?? '',
        processModule: filter.processModule ?? '',
      },
    });
  }


  exportOpenMattersToEmail(filter: any, format: 'excel' | 'csv'): Observable<{ jobId: string }> {
    return this.http.post<{ jobId: string }>(this.baseUrl + '/api/app/report/export-open-matters-to-email', {
      filter: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? '',
        companyName: filter.companyName ?? '',
        workflowTemplate: filter.workflowTemplate ?? [],
        matterProgressStatus: filter.matterProgressStatus ?? [],
        matterOpenedDateStart: filter.matterOpenedDateStart ?? '',
        matterOpenedDateEnd: filter.matterOpenedDateEnd ?? '',
        processModule: filter.processModule ?? '',
      },
      format: format
    });
  }

  getFNDetailReportList(filter: any): Observable<FNDetailsReport[]> {
    return this.http.get<FNDetailsReport[]>(this.baseUrl + '/api/app/report/f-nDetails-report', {
      params: {
        companyName: filter.companyName ?? [],

      },
    });
  }

  exportFNDetailsToEmail(filter: any, format: 'excel' | 'csv'): Observable<{ jobId: string }> {
    return this.http.post<{ jobId: string }>(this.baseUrl + '/api/app/report/export-fNDetails-report-to-email', {
      filter: {
        idExcluded: filter.idExcluded ?? '',
        companyName: filter.companyName ?? '',
      },
      format: format
    });
  }
  getRecruitmentReportList(filter: any): Observable<RecruitmentReport[]> {
    return this.http.get<RecruitmentReport[]>(this.baseUrl + '/api/app/report/recruitment-report', {
      params: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? '',
        companyName: filter.companyName ?? [],
        matterActiveStatus: filter.matterActiveStatus ?? '',
        partnerCompanyType: filter.partnerCompanyType ?? '',
        otherCaseManager: filter.otherCaseManager ?? '',
      },
    });
  }
  exportRecruitmentReportToEmail(filter: any, format: 'excel' | 'csv'): Observable<{ jobId: string }> {
    return this.http.post<{ jobId: string }>(this.baseUrl + '/api/app/report/export-recruitment-report-to-email', {
      filter: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? '',
        companyName: filter.companyName ?? [],
        matterActiveStatus: filter.matterActiveStatus ?? '',
        partnerCompanyType: filter.partnerCompanyType ? Number(filter.partnerCompanyType) : null,
        otherCaseManager: filter.otherCaseManager ?? '',
      },
      format: format
    });
  }
  getExperienceMapReportList(filter: any): Observable<ExperienceMapReport[]> {
    return this.http.get<ExperienceMapReport[]>(this.baseUrl + '/api/app/report/experience-map-report', {
      params: {
        idExcluded: filter.idExcluded ?? '',
        primaryCaseManager: filter.primaryCaseManager ?? '',
        primarySigningAttorney: filter.primarySigningAttorney ?? '',
        companyName: filter.companyName ?? [],
        matterActiveStatus: filter.matterActiveStatus ?? '',
        matterID: filter.matterID ?? '',
        fnName: filter.fnName ?? '',
      },
    });
  }

  getPWDWithoutRecruitmentList(filter?: PWDsWithoutRecruitmentFilter): Observable<PWDsWithoutRecruitment[]> {
    return this.http.get<PWDsWithoutRecruitment[]>(this.baseUrl + '/api/app/report/p-wDWithout-recruitment', {
      params: {
        primaryCaseManager: filter?.primaryCaseManager ?? '',
        companyName: filter?.companyName ?? '',
        pwdExpirationDateFrom: filter?.pwdExpirationDateFrom ?? '',
        pwdExpirationDateTo: filter?.pwdExpirationDateTo ?? '',
      },
    });
  }

  exportPWDWithoutRecruitmentToEmail(filter: PWDsWithoutRecruitmentFilter, format: 'excel' | 'csv'): Observable<{ jobId: string }> {
    return this.http.post<{ jobId: string }>(this.baseUrl + '/api/app/report/export-pWDWithout-recruitment-to-email', {
      filter: {
        primaryCaseManager: filter?.primaryCaseManager ?? '',
        companyName: filter?.companyName ?? '',
        pwdExpirationDateFrom: filter?.pwdExpirationDateFrom,
        pwdExpirationDateTo: filter?.pwdExpirationDateTo,
      },
      format: format
    });
  }

  getPermExpirationList(filter: any): Observable<PERMExpiration[]> {
    const params: any = {};

    if (filter.activeStatus !== undefined && filter.activeStatus !== null && filter.activeStatus !== '') {
      params.activeStatus = filter.activeStatus;
    }
    return this.http.get<PERMExpiration[]>(this.baseUrl + '/api/app/report/p-eRMExpiration-report', {
      params: params,
    });
  }

    getLegacyReviewReportList(filter: any): Observable<LegacyReviewReport[]> {
    return this.http.get<LegacyReviewReport[]>(this.baseUrl + '/api/app/report/legacy-review-report', {
      params: {
        status: filter.status ?? '',
        entityType: filter.entityType ?? '',
      },
    });
  }

  // getVisaBulletionReport(filter: any): Observable<VisaBulletinReport[]> {
  //   let params = new HttpParams();

  //   // 添加基本参数
  //   if (filter.month) {
  //     params = params.set('month', filter.month);
  //   }

  //   // 处理多选类型 - 为每个选中的类型添加单独的 type 参数
  //   if (filter.type && Array.isArray(filter.type) && filter.type.length > 0) {
  //     filter.type.forEach((type: any) => {
  //       params = params.append('type', type.toString());
  //     });
  //   } else if (filter.type) {
  //     // 如果类型不是数组，保持向后兼容
  //     params = params.set('type', filter.type.toString());
  //   }

  //   if (filter.sponsor) {
  //     params = params.set('sponsor', filter.sponsor);
  //   }

  //   if (filter.companyName) {
  //     params = params.set('companyName', filter.companyName);
  //   }

  //   return this.http.get<VisaBulletinReport[]>(this.baseUrl + '/api/app/report/visa-bulletin-report', {
  //     params: params
  //   });
  // }
  downloadAuditReport(startTime: string, endTime: string) {
    return this.http.get<FileWithContentDto>(this.baseUrl + '/api/app/report/audit-report', {
      params: { startTime, endTime }
    });
  }
}
